import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-brand-dark pt-6 pb-10 px-4 sm:px-6 lg:px-8" data-id="element-44">
      {/* Background Effects */}
      <div className="absolute inset-0 z-0" data-id="element-45">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(200,149,43,0.15)_0%,transparent_60%)]" data-id="element-46" />
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23C8952B' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-47" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-6 flex flex-col items-center" data-id="element-49">
          <img src="https://cdn.magicpatterns.com/uploads/8hUDA6joQrrT3cXREsAXGY/Untitled_design_10.png" alt="Reclutas Digitales Logo" className="h-48 md:h-64 object-contain drop-shadow-[0_0_15px_rgba(200,149,43,0.3)]" data-id="element-50" />
          <div className="inline-block bg-brand-white border border-brand-gold/30 rounded-full px-5 py-2 mt-1 shadow-sm" data-id="element-51">
            <p className="text-sm md:text-base font-medium text-brand-gold" data-id="element-52">
              "No somos una agencia de marketing. Somos el equipo que conoce tu
              negocio desde dentro."
            </p>
          </div>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-heading font-bold text-4xl md:text-6xl lg:text-7xl uppercase tracking-tight text-brand-text mb-3 leading-tight" data-id="element-53">
          Tu problema no es reclutar
          <br data-id="element-54" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-brand-gold-bright" data-id="element-55">
            Es no tener control
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-brand-text-muted max-w-3xl mx-auto mb-5 leading-relaxed" data-id="element-56">
          Deja de depender de referidos, suerte o tu upline. Construye una
          operación con estructura para atraer, dar seguimiento y activar
          agentes de forma predecible.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-57">
          <a href="https://www.skool.com/reclutas-digitales-4277" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-brand-gold to-brand-gold-bright text-brand-black font-heading font-bold uppercase tracking-wide rounded-md hover:shadow-[0_0_20px_rgba(232,184,74,0.4)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-58">
            ENTRAR A SKOOL
          </a>
          <a href="#modulos" className="w-full sm:w-auto px-8 py-4 bg-transparent border-2 border-brand-gold text-brand-gold font-heading font-bold uppercase tracking-wide rounded-md hover:bg-brand-gold/10 transition-all duration-300 flex items-center justify-center gap-2" data-id="element-59">
            VER MÓDULOS
            <ArrowDownIcon className="w-5 h-5" data-id="element-60" />
          </a>
        </motion.div>
      </div>
    </section>;
}